import { createFileRoute } from '@tanstack/react-router';
import FolderIndexPage from '../components/FolderIndexPage';
import { validateListPageSearch } from '../utils/listPageSearch';

export const Route = createFileRoute('/_app/folder/$folderId/')({
  validateSearch: validateListPageSearch,
  component: FolderIndexPage,
});
